"use strict";
var menu_directive_1 = require("./menu.directive");
exports.NguiMenuDirective = menu_directive_1.NguiMenuDirective;
var menu_module_1 = require("./menu.module");
exports.NguiMenuModule = menu_module_1.NguiMenuModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/menu/dist/index.js
// module id = 547
// module chunks = 4